export function createPersonRequest(
  name, 
  birthday, 
  status, 
  ocupation, 
  family_count, 
  cpf, 
  nis, 
  contact, 
  address, 
  neighborhood
) {
  return {
    type: '@person/CREATE_PERSON_REQUEST',
    payload: {
      name, 
      birthday, 
      status, 
      ocupation, 
      family_count, 
      cpf, 
      nis, 
      contact, 
      address, 
      neighborhood
    },
  };
}

export function createPersonSuccess(personData) {
  return {
    type: '@person/CREATE_PERSON_SUCCESS',
    payload: { personData },
  };
}

export function createPersonFailure() {
  return {
    type: '@person/CREATE_FAILURE',
  };
} 



export function updatePersonRequest(  
  name, 
  birthday, 
  status, 
  ocupation, 
  family_count, 
  cpf,
  nis, 
  contact, 
  address, 
  neighborhood,
  createdby
  ) {
  return {
    type: '@person/UPDATE_PERSON_REQUEST',
    payload: { 
      name, 
      birthday, 
      status, 
      ocupation, 
      family_count,
      cpf, 
      nis, 
      contact, 
      address, 
      neighborhood,
      createdby
     },
  };
}

export function updatePersonSuccess(updatedData) {
  return {
    type: '@person/UPDATE_PERSON_SUCCESS',
    payload: { updatedData },
  };
}

export function updatePersonFailure() {
  return {
    type: '@person/UPDATE_FAILURE',
  };
} 